import { Alert } from "antd";
import { Link } from "react-router-dom";

import { useAccount } from "./hooks";

function toNumber(value: string | undefined): number {
  const n = Number.parseFloat(value ?? "0");
  return Number.isFinite(n) ? n : 0;
}

/**
 * A top-of-page banner warning the customer about account state (suspended, or
 * an outstanding balance) — AWS-style, so problems aren't a surprise. Renders
 * nothing when the account is healthy or billing data isn't available.
 */
function AccountBanner() {
  const { data } = useAccount();
  if (!data) return null;

  const suspended = (data.account_status ?? "").toLowerCase() === "suspended";
  const outstanding = toNumber(data.outstanding);

  if (suspended) {
    return (
      <Alert
        type="error"
        showIcon
        banner
        message="Your account is suspended — new resources can't be created until any outstanding balance is settled."
        action={<Link to="/billing">View billing</Link>}
        style={{ marginBottom: 8 }}
      />
    );
  }

  if (outstanding > 0) {
    return (
      <Alert
        type="warning"
        showIcon
        banner
        message={`You have an outstanding balance of $${outstanding.toFixed(2)}.`}
        action={<Link to="/billing">Pay now</Link>}
        style={{ marginBottom: 8 }}
      />
    );
  }

  return null;
}

export default AccountBanner;
